import { useAction } from "@/utils/useQuery/useAction";
import { genericMutation } from "@/utils/useQuery/utils/genericMutation";

export function useValidateMagicLink() {
	return useAction({
		fn: (arg) => {
			const query = new URLSearchParams();
			query.append("code", arg.query?.code);
			query.append("token", arg.query?.token);
			return genericMutation({ url: `/auth/magicLink?${query.toString()}`, method: "get" });
		},
	});
}
